// src/hooks/currencies/useRestoreAllCurrencies.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllCurrencies } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useRestoreAllCurrencies() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: restoreAllCurrenciesMutation, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllCurrencies,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم استعادة العملات المحددة بنجاح" : "Selected currencies restored successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في استعادة العملات" : "Failed to restore currencies"));
        },
    });

    return { restoreAllCurrencies: restoreAllCurrenciesMutation, isRestoreAll };
}

export default useRestoreAllCurrencies;
